import {
    Link,
    Typography,
} from "@mui/material";
import React from "react";

export default function PageNotFound() {
    return (
        <div>
            <Typography variant="h4">404 Page Not Found</Typography>
            <Typography variant="body2">
                The page you requested could not be found.
            </Typography>
            <Link href="/">
                <Typography variant="body2">Go Home</Typography>
            </Link>
        </div>
    );
}